import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import stringWithWBR from 'lib/tags/string-with-wbr'
import PriceWithSeparateCents from '~/scenes/shared/price-with-separate-cents'

export default function OtherCourses ({ courses }) {
  return (
    <div>
      {courses.map(course => (
        <div key={course.id} className='widget nospace2'>
          <div className='coursebox'>
            <div className='course_title_container'>
              <div className='course_price'>
                <PriceWithSeparateCents priceSeparateCents={course.price} perHourClass='per-hour' />
              </div>
              <h2 className='course_title profile-course-title'>
                <a href={course.url}>{stringWithWBR(course.title)}</a>
              </h2>
            </div>
          </div>
          <div className='undercoursebox'>
            <div className='course_description'>{course.description}</div>
            <div className='read-more-container'>
              <a className='readmore' href={course.url}>
                {I18n.t('profiles.show_courses.read_more')}
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

OtherCourses.propTypes = {
  courses: PropTypes.array
}
